module.exports = __webpack_public_path__ + "img/pais.0be5e0da.jpg";